import React from 'react';
import {setShowDialog, store} from '../../utils/redux';

export default function MergeReportDlg({autoNotes, conflictNotes, onConfirm}) {
    const close = () => store.dispatch(setShowDialog(false))

    return (<div style={{background: 'white', padding: '20px', borderRadius: '8px', maxWidth: '500px', maxHeight: '80vh', overflowY: 'auto'}}>
        <p style={{marginTop: 0}}>
            Jemand anderes hat zwischenzeitlich gespeichert. Deine Änderungen wurden automatisch mit
            dem aktuellen Stand zusammengeführt, statt ihn einfach zu überschreiben.
        </p>
        {autoNotes.length > 0 && <>
            <p style={{marginBottom: '5px'}}><strong>✅ Automatisch zusammengeführt ({autoNotes.length})</strong></p>
            <ul style={{marginTop: 0}}>
                {autoNotes.map((n, i) => <li key={i}>{n}</li>)}
            </ul>
        </>}
        {conflictNotes.length > 0 && <>
            <p style={{marginBottom: '5px'}}><strong>⚠️ Bitte manuell prüfen ({conflictNotes.length})</strong></p>
            <ul style={{marginTop: 0}}>
                {conflictNotes.map((n, i) => <li key={i}>{n}</li>)}
            </ul>
        </>}
        <p>
            Der zusammengeführte Stand wurde als dein aktueller (noch nicht hochgeladener) Plan
            übernommen. Bitte oben genannte Punkte prüfen und danach erneut auf "Upload" klicken.
        </p>
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <button onClick={() => {
                close()
                if (typeof onConfirm === 'function') onConfirm()
            }}>Verstanden
            </button>
        </div>
    </div>)
}
